import React from "react";
import { Link } from "react-scroll";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Badge from "@mui/material/Badge";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useTransaksiStore } from "../../../stores/transaksiStore";

const TransaksiCartFab = () => {
    const cart = useTransaksiStore((s) => s.cart);

    return (
        <Link
            activeClass="active"
            to="barangPesanan"
            spy={true}
            smooth={true}
            duration={500}
        >
            <Box
                sx={{
                    display: { xs: "block", md: "none" },
                    position: "fixed",
                    bottom: "max(70px, calc(env(safe-area-inset-bottom) + 16px))",
                    right: { xs: 8, sm: 16 },
                }}
            >
                <Badge
                    badgeContent={cart.length}
                    color="secondary"
                    overlap="circular"
                >
                    <Fab color="primary" aria-label="add">
                        <ShoppingCartIcon />
                    </Fab>
                </Badge>
            </Box>
        </Link>
    );
};

export default TransaksiCartFab;
